import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "animate.css";
import { ref, onMounted, computed, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "Header",
  setup: function setup() {
    var selectItemStr = ref(''); // 切换中英文

    var gloalflag = ref(false);
    var newsflag = ref(false);
    var weixinFlag = ref(false);

    var hoverNews = function hoverNews(val) {
      newsflag.value = true;
      gloalflag.value = false;
    };

    var hoverGlobal = function hoverGlobal(val) {
      gloalflag.value = true;
      newsflag.value = false;
      selectItemStr.value = '/' + val;
    };

    var leaveGlobal = function leaveGlobal() {
      gloalflag.value = false;
      selectItemStr.value = route.path;
    };

    var leaveNews = function leaveNews() {
      newsflag.value = false;
    }; // 搜索


    var searchFlag = ref(false);

    var searchClick = function searchClick() {
      searchFlag.value = !searchFlag.value;
    };

    var showWeixin = function showWeixin() {
      weixinFlag.value = true;
    };

    var leaveWeixin = function leaveWeixin() {
      weixinFlag.value = false;
    };

    var searchValue = ref('');
    var router = useRouter();
    var route = useRoute();
    var showSearch = ref(true); //控制搜索框显示隐藏
    // 监听路由变化
    // watch(
    // ()=>{
    //   // console.log('route=',route.path /mediaDetails);
    //   if(route.path!='/report'&&route.path!='/mediaDetails'){
    //     showSearch.value = false
    //   }else{
    //     showSearch.value = true
    //     searchFlag.value = false
    //   }
    // }
    // )

    var showList = ref(true); //是否显示pc端关于昨非的下拉列表

    var showMobileList = ref(false); //移动端导航

    var showCompile = ref(false); //移动端导航中 公司简介 导航是否高亮

    var showCore = ref(false); //移动端导航中 核心价值观 导航是否高亮

    var showHistory = ref(false); //移动端导航中 发展历程 导航是否高亮

    var searchMedia = function searchMedia() {
      // console.log(123);
      // window.open(`https://www.baidu.com/s?wd=${searchValue.value}`)  }
      router.push({
        path: '/report',
        query: {
          wd: searchValue.value
        }
      });
    };

    var showAbout = computed(function () {
      if (route.path == "/history") {
        return true;
      } else {
        return false;
      }
    }); //当前路径为发展历程时，about导航是否高亮
    //事件
    //鼠标移入展示下拉列表

    function enterList() {
      showList.value = true;
    } //鼠标移出收起下拉列表


    function leaveList() {
      showList.value = false;
    } // //点击按钮切换导航显示状态


    function changeMobileList() {
      showMobileList.value = !showMobileList.value;
    }

    var longFlag = ref("en");

    var changeLang = function changeLang(long) {
      if (long == "cn") {
        if (longFlag.value != "cn") {
          longFlag.value = "cn"; // router.push({ path: "/index" })
        } // 使用 fullPath 携带 query/hash（例如 mediaDetails 详情页参数）


        window.location.href = "https://www.tenacia.com" + route.fullPath; // window.location.href = "https://webtest.tenacia.com/" + routerStr 
        // if(route.path == '/'){
        // window.location.href = "https://tenacia.insightin.cn/"
        // }
        // if(route.path == '/a'){
        //  window.location.href = "https://tenacia.insightin.cn/"
        // }
      } else {
        if (longFlag.value != "en") {
          longFlag.value = "en"; // router.push({ path: "/enIndex" })
        } // router.push({ path: "/enIndex" })

      }
    }; //点击移动端导航跳转路由并隐藏导航


    function navRouterJump(title) {
      // return
      //判断是否点击了对应的导航
      if (title == "compile" || title == "core") {
        goAbout(title); //调用跳转指定位置的函数
      }

      if (title == "compile") {
        //当点击 移动端的 公司简介 导航时
        showCompile.value = true; //移动端导航中 公司简介 导航高亮

        showCore.value = false; //重置移动端导航中 核心价值观 导航显示状态

        showHistory.value = false; //重置移动端导航中 发展历程 导航显示状态
      } else if (title == "core") {
        //当点击 移动端的 核心价值观 导航时
        showCore.value = true; //移动端导航中 核心价值观 导航高亮

        showCompile.value = false; //重置移动端导航中 公司简介 导航显示状态

        showHistory.value = false; //重置移动端导航中 发展历程 导航显示状态
      } else if (title == "history") {
        //当点击 移动端的 核心价值观 导航时
        showHistory.value = true; //移动端导航中 发展历程 导航高亮

        showCompile.value = false; //重置移动端导航中 公司简介 导航显示状态

        showCore.value = false; //重置移动端导航中 核心价值观 导航显示状态
      } else {
        showCompile.value = false; //重置移动端导航中 公司简介 导航显示状态

        showCore.value = false; //重置移动端导航中 核心价值观 导航显示状态

        showHistory.value = false; //重置移动端导航中 发展历程 导航显示状态
      }

      showMobileList.value = false; //收起导航
    }

    var colorState = ref(false); //跳转到指定页面页面/并滚动到指定位置

    function goAbout(title) {
      //跳转到about页面
      router.push({
        path: "/about"
      }); //将该函数包裹一个定时器确保可以获取跳转页面后的指定位置的id

      setTimeout(function () {
        if (title == "compile") {
          var goContent = document.getElementById("compileContent");
        } else if (title == "core") {
          var goContent = document.getElementById("coreContent");
        }

        goContent.scrollIntoView({
          behavior: "smooth",
          //平滑滚动
          block: "center" //将指定位置滚动到页面中间

        });
      }, 100);
    }

    onMounted(function () {
      // console.log(route.path);
      var longContainer = document.querySelector('.long-container'); // console.log(longContainer.classList,'获取到元素了吗');

      window.addEventListener('scroll', function () {
        var scrollY = window.scrollY; // console.log(scrollY,'是多少');

        if (scrollY > 300) {
          longContainer.classList.add('fixed-container');
          colorState.value = false; // console.log(longContainer.classList,'获取到元素了吗');
        } else {
          longContainer.classList.remove('fixed-container');
        }

        if (scrollY == 0 && route.path == "/" || route.path == "/index") {
          colorState.value = true;
        }
      });
      setTimeout(function () {
        if (route.path == "/" || route.path == "/index") {
          // console.log(route.path, '这是首页')
          selectItemStr.value = '/';
          colorState.value = true;
        } else {
          selectItemStr.value = route.path;
        }

        if (route.path == "/enIndex") {
          longFlag.value = "en";
        }
      }, 500);
    }); // 跳转到关于元羿的指定模块

    var jumpTo = function jumpTo(val) {
      gloalflag.value = false;
      newsflag.value = false;
      colorState.value = false;

      if (route.path == '/aboutUs') {
        var hash = '#' + val; // console.log('hash:', hash)

        if (hash.indexOf('#') != -1) {
          nextTick(function () {
            var id = hash.split('#')[1];
            id = decodeURIComponent(id);
            var el = document.getElementById(id); // console.log('滚动到：', id, el)

            if (el) {
              // 平滑滚动
              setTimeout(function () {
                el.scrollIntoView({
                  behavior: 'smooth'
                });
              }, 0);
            }
          });
        }
      }

      router.replace({
        path: '/aboutUs',
        hash: "#".concat(val)
      }); // router.go(0)
      // window.location.reload()
    };

    var jumpNews = function jumpNews(val) {
      gloalflag.value = false;
      newsflag.value = false;
      colorState.value = false;

      if (route.path == '/report') {
        var hash = '#' + val; // console.log('hash:', hash)

        if (hash.indexOf('#') != -1) {
          nextTick(function () {
            var id = hash.split('#')[1];
            id = decodeURIComponent(id);
            var el = document.getElementById('pressRelease'); // console.log('滚动到：', id, el)

            if (el) {
              // 平滑滚动
              setTimeout(function () {
                el.scrollIntoView({
                  behavior: 'smooth'
                });
              }, 0);
            }
          });
        }
      }

      router.replace({
        path: '/report',
        hash: "#".concat(val)
      });
    };

    var selectItem = function selectItem(val) {
      selectItemStr.value = val;
      colorState.value = false;

      if (val === '/') {
        colorState.value = true;
      }

      leaveGlobal();
      leaveNews();
    }; //跳转发展历程页面


    function goHistory() {
      router.push({
        path: "/history"
      });
    }

    return {
      showList: showList,
      showMobileList: showMobileList,
      showCompile: showCompile,
      showCore: showCore,
      showHistory: showHistory,
      showAbout: showAbout,
      enterList: enterList,
      leaveList: leaveList,
      changeMobileList: changeMobileList,
      navRouterJump: navRouterJump,
      goAbout: goAbout,
      goHistory: goHistory,
      gloalflag: gloalflag,
      longFlag: longFlag,
      changeLang: changeLang,
      hoverGlobal: hoverGlobal,
      leaveGlobal: leaveGlobal,
      searchFlag: searchFlag,
      searchClick: searchClick,
      searchMedia: searchMedia,
      showSearch: showSearch,
      searchValue: searchValue,
      selectItemStr: selectItemStr,
      selectItem: selectItem,
      jumpTo: jumpTo,
      colorState: colorState,
      newsflag: newsflag,
      hoverNews: hoverNews,
      leaveNews: leaveNews,
      jumpNews: jumpNews,
      weixinFlag: weixinFlag,
      showWeixin: showWeixin,
      leaveWeixin: leaveWeixin
    };
  }
};